var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block !important"},attrs:{"id":"adsbygoogle","data-ad-client":"ca-pub-6711015484900349","data-ad-slot":"5268012972","data-ad-format":"auto","data-full-width-responsive":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }